require('./brokerInternalTransferFundsPreStep.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');

// @commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const OKModal = require('components/commons/OKModal/OKModal');

// @components
const DropdownFunds = require('components/broker/brokerDropdownFunds/dropdownFunds');
const { BrokerAdvancedSearchExplore } = require('components/broker/brokerAdvancedSearch/brokerAdvancedSearchExplore/brokerAdvancedSearchExplore');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const {
    FIRST_STEP,
    BROKER_INTERNAL_TRANSFER_NEW_FUND,
    BROKER_INTERNAL_TRANSFER_EXISTING_FUND
} = require('constants/index');

class BrokerInternalTransferFundsPreStep extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: true,
        };
        this.handleInputSearchFundSelected = this.handleInputSearchFundSelected.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleSetOriginFundChange = this.handleSetOriginFundChange.bind(this);
        this.handleSetDestinationFundChange = this.handleSetDestinationFundChange.bind(this);
        this.handleContinueWithoutSameIsinVerification = this.handleContinueWithoutSameIsinVerification.bind(this);

    }

    handleCloseModal() {
        this.setState ({
            showModal: false,
        });
    }

    buildModalWarning() {
        const modalText = formatText('brokerInternalTransferFundsPreStep-brokerInternalTransferFundsPreStep_modalDescription');
        const modalButtonText = formatText('brokerInternalTransferFundsPreStep-brokerInternalTransferFundsPreStep_modalButtonText');
        return (
            <OKModal
                description={modalText}
                isOpen={this.state.showModal}
                onCloseCallback={this.handleCloseModal}
                onPrimaryButtonClick={this.handleCloseModal}
                footerType="action"
                primaryButtonText={modalButtonText}
            />
        );
    }

    handleSetOriginFundChange(fundId) {
        const { setOriginFundChange, immBrokerMyInvestments, immFlagBasedFeatures } = this.props;
        const immFundSelected = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']).find( fund => fund.get('id') === fundId );
        const linkedToRobo = !!immFundSelected ? immFundSelected.get('isBlockedByRobo') : false;
        const immFundsContributionsList = immBrokerMyInvestments.getIn(['fundsContributionsList', 'list', 'recurringTransfers']);
        const contractCode = immFundSelected.get('numerodecontrato');
        const contribution = immFundsContributionsList.find(contribution => contribution.get('contractCode') === contractCode);
        const hasContribution = immFundsContributionsList.some(contribution => contribution.get('contractCode') === contractCode);
        const contributionsAllowed = immFlagBasedFeatures.get('wealth_funds_periodic_contributions')

        if (linkedToRobo) {
            this.setState({
                showModal: true,
            });
        }

        if (contributionsAllowed) {
            setOriginFundChange(fundId, linkedToRobo, hasContribution, contribution);
        } else {
            setOriginFundChange(fundId, linkedToRobo, false);
        }

    }

    handleSetDestinationFundChange(fundId) {
        const { setDestinationFund, immBrokerMyInvestments, immFlagBasedFeatures  } = this.props;
        const immFundSelected = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']).find( fund => fund.get('id') === fundId );
        const linkedToRobo = !!immFundSelected ? immFundSelected.get('isBlockedByRobo') : false;
        const immFundsContributionsList = immBrokerMyInvestments.getIn(['fundsContributionsList', 'list', 'recurringTransfers']);
        const contractCode = immFundSelected.get('numerodecontrato');
        const contribution = immFundsContributionsList.find(contribution => contribution.get('contractCode') === contractCode);
        const hasContribution = immFundsContributionsList.some(contribution => contribution.get('contractCode') === contractCode);
        const contributionsAllowed = immFlagBasedFeatures.get('wealth_funds_periodic_contributions')

        if (linkedToRobo) {
            this.setState({
                showModal: true,
            });
        }
        if (contributionsAllowed)
            setDestinationFund(fundId, linkedToRobo, hasContribution, contribution);
        else {
            setDestinationFund(fundId, linkedToRobo, false);
        }
    }

    buildDestinationFundDropdown() {
        const { immBrokerInternalTransferFunds, immDestinationFunds } = this.props;
        const originFund = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'originFund']);
        const destinationFund = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'destinationFund']);
        const destinationFundValid = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'destinationFundValid']);
        const enabled = immDestinationFunds.size > 0;

        const notAvailableResult = formatText('internalTransferFundSelectFundsStep-noExistingFunds');

        const empty = immDestinationFunds.size == 0 && !!originFund ?
            (
                <div className="broker-internal-transfer-funds-pre-step__empty-funds">
                    <EmptyState primaryText={notAvailableResult} iconType="noitems-wealth"/>
                </div>
            ) : undefined;

        return (
            <div className="broker-internal-transfer-funds-pre-step__dropdown-container--destination">
                <DropdownFunds
                    id="broker-destination-funds"
                    immFunds={immDestinationFunds}
                    currentFundId={destinationFund}
                    onFundChange={this.handleSetDestinationFundChange}
                    error={!destinationFundValid}
                    errorMsg={formatText('broker-internalTransferFundEmptyToAccountError')}
                    enabled={enabled}
                />
                {empty}
            </div>
        );
    }

    buildErrorMessage() {
        const { immBrokerInternalTransferFunds } = this.props;
        const newFundSelectedValid = immBrokerInternalTransferFunds.getIn(['steps', 0, 'newFundSelectedValid'])
        if (!newFundSelectedValid) {
            return (
                <FormattedText value="internalTransferFundSelectFundsStep-noDestinationFundSelected" className="broker-internal-transfer-funds-pre-step__error-msg" />
            )
        }
    }

    buildOriginFundDropdown() {
        const { immBrokerInternalTransferFunds, immBrokerMyInvestments, immFunds } = this.props;

        const originFund = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'originFund']);
        const immFundSelected = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']).find( fund => fund.get('id') === originFund );
        const linkedToRobo = !!immFundSelected ? immFundSelected.get('isBlockedByRobo') : false;
        const originFundValid = immBrokerInternalTransferFunds.getIn([
            'steps',
            FIRST_STEP,
            'originFundValid'
        ]);

        return (
            <div className="broker-internal-transfer-fund-select-funds-step__dropdown-container">
                <label className="ok-select__label">
                    {formatText('internalTransferFundSelectFundsStep-originFund')}
                </label>
                <OKTooltip
                    content="internalTransferFundSelectFundsStep-originFundTooltip"
                    offset={[2,-15]}
                />
                <DropdownFunds
                    id="broker-origin-funds"
                    immFunds={immFunds}
                    currentFundId={originFund}
                    onFundChange={this.handleSetOriginFundChange}
                    error={!originFundValid || linkedToRobo}
                    errorMsg={formatText('broker-internalTransferFundEmptyFromAccountError')}
                />
            </div>
        );
    }

    handleHideModal = () => {
        const { hideModalSelectFunds, onChangeFundType } = this.props
        hideModalSelectFunds()
        onChangeFundType('existing')
    }

    handleNoVerify = () => {
        const { hideModalSelectFunds, onNextClick, history } = this.props
        hideModalSelectFunds()
        onNextClick(history, false)
    }

    buildRadioButtons() {
        const { immBrokerInternalTransferFunds, immFunds } = this.props;
        const fundType = immBrokerInternalTransferFunds.getIn(['steps', 0, 'fundType']);
        let fundOperation;
        if (fundType === BROKER_INTERNAL_TRANSFER_EXISTING_FUND) {
            fundOperation = (
                <div>
                    {this.buildDestinationFundDropdown()}
                </div>
            );
        } else {
            const fundsToFilter = [];
            immFunds.forEach(immFund => {
                if (immFund.get('isin')) {
                    fundsToFilter.push(immFund.get('isin'));
                }
            });

            fundOperation = (
                <div className="broker-internal-transfer-funds-pre-step__results">
                    <div className="broker-internal-transfer-funds-pre-step__input-search">
                        <BrokerAdvancedSearchExplore
                            isModal={true}
                            onHandleProductSelect={this.handleInputSearchFundSelected}
                            isModalFund={true}
                            embeddedSearch={true}
                            selectedNewFund={this.props.selectedNewFund}
                            isInternalTransferFund={true}
                            isExternalTransferFund={false}
                            fundsToFilter={fundsToFilter}
                        />
                    </div>
                    {this.buildErrorMessage()}
                </div>
            )
        }

        return (
            <div>
                <RadioButtonGroup
                    idPrefix="internalTransferFundType"
                    name="fundType"
                    className="broker-internal-transfer-funds-step1__radio-button-group"
                    selectedValue={fundType}
                    onChange={this.props.onChangeFundType}
                >
                    <RadioButton
                        value={BROKER_INTERNAL_TRANSFER_EXISTING_FUND}
                        label={formatText('internalTransferFundSelectFundsStep-existingFund')}
                        className="broker-internal-transfer-funds-step1__radio-button-yes"
                    />
                    <RadioButton
                        value={BROKER_INTERNAL_TRANSFER_NEW_FUND}
                        label={formatText('internalTransferFundSelectFundsStep-newFund')}
                        className="broker-internal-transfer-funds-step1__radio-button-no"
                    />
                </RadioButtonGroup>
                {fundOperation}
            </div>

        )
    }

    handleInputSearchFundSelected(product) {
        this.props.inputSearchFundSelected(product);
    }

    handleContinueWithoutSameIsinVerification() {
        const { onNextClick } = this.props;
        onNextClick(history, false)
    }

    render() {
        const { immBrokerInternalTransferFunds, immBrokerMyInvestments } = this.props;
        const originFund = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'originFund']);
        const immOriginFundSelected = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']).find( fund => fund.get('id') === originFund);
        const destinationFund = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'destinationFund']);
        const immDestinationFundSelected = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']).find( fund => fund.get('id') === destinationFund);
        const originLinkedToRobo = !!immOriginFundSelected ? immOriginFundSelected.get('isBlockedByRobo') : false;
        const destinationLinkedToRobo = !!immDestinationFundSelected ? immDestinationFundSelected.get('isBlockedByRobo') : false;
        const modalWarning = originLinkedToRobo || destinationLinkedToRobo ? this.buildModalWarning(): null;
        return (
            <OKSectionBox className="broker-internal-transfer-funds-pre-step">
                <OKBoxTitle
                    className="broker-internal-transfer-funds-pre-step__title"
                    value={formatText("internalTransferFundSelectFundsStep-title")} />
                <p className="broker-internal-transfer-funds-pre-step__info">
                    <FormattedText value="internalTransferFundSelectFundsStep-selectFund" />
                </p>

                <div className="broker-internal-transfer-funds-pre-step__dropdown-container">
                    {this.buildOriginFundDropdown()}
                    {modalWarning}
                </div>
                <label className="ok-select__label">
                    {formatText('internalTransferFundSelectFundsStep-destinationFund')}
                </label>
                <OKTooltip
                    content="internalTransferFundSelectFundsStep-destinationFundTooltip"
                    offset={[2,-15]}
                />
                {this.buildRadioButtons()}
                <footer className="broker-internal-transfer-funds-pre-step__footer">
                    <div className="row">
                        <div className="col-xs-6">
                            <OKButton
                                onClick={this.props.onCancelClick}
                                modifier="link-ghost"
                            >
                                <FormattedText value="internalTransferFundSelectFundsStep-cancel" />
                            </OKButton>
                        </div>
                        <div className="col-xs-6 text-right">
                            <OKButton
                                modifier="secondary"
                                rightIcon="icon-siguiente"
                                onClick={this.handleContinueWithoutSameIsinVerification}
                                loading={this.props.immBrokerInternalTransferFunds.get(
                                    'stepSelectFundsLoading'
                                )}
                                disabled={originLinkedToRobo || destinationLinkedToRobo}
                            >
                                <FormattedText value="internalTransferFundSelectFundsStep-next" />
                            </OKButton>
                        </div>
                    </div>
                </footer>
            </OKSectionBox>
        );
    }
}

BrokerInternalTransferFundsPreStep.propTypes = {
    history: PropTypes.object.isRequired,
    immDestinationFunds: PropTypes.object.isRequired,
    immBrokerInternalTransferFunds: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immFunds: PropTypes.object.isRequired,
    setOriginFundChange: PropTypes.func.isRequired,
    setDestinationFund: PropTypes.func.isRequired,
    onNextClick: PropTypes.func.isRequired,
    onCancelClick: PropTypes.func.isRequired,
    selectedNewFund: PropTypes.string,
    inputSearchFundSelected: PropTypes.func.isRequired,
    onChangeFundType: PropTypes.func.isRequired,
    hideModalSelectFunds: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired
};

module.exports = withRouter(BrokerInternalTransferFundsPreStep);
